"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            outlines: [],
            editOutline: false,
            mountModuleIndex: null,
            waiting: false
        };
        this.selectedContentType = null;
        this.contextModal = {
            label: 'Add Course Content',
            instructions: 'Select from the options listed below',
            options: {
                module: [{
                        label: 'Module',
                        value: 'module',
                        fn: this.onAddContent.bind(this)
                    }],
                lesson: [
                    {
                        label: 'Text Content',
                        value: 'RTXT',
                        fn: this.onAddContent.bind(this)
                    },
                    {
                        label: 'Flip Content',
                        value: 'FLIP',
                        fn: this.onAddContent.bind(this)
                    },
                    {
                        label: 'Video Content',
                        value: 'MVID',
                        fn: this.onAddContent.bind(this)
                    },
                    {
                        label: 'Simulation',
                        value: 'SMLT',
                        fn: this.onAddContent.bind(this)
                    },
                    {
                        label: 'Live Session',
                        value: 'LIVE',
                        fn: this.onAddContent.bind(this)
                    }
                ],
                evaluation: [
                    {
                        label: 'Test/Assessment',
                        value: 'ASSM',
                        fn: this.onAddContent.bind(this)
                    },
                    {
                        label: 'Assignment',
                        value: 'ASSG',
                        fn: this.onAddContent.bind(this)
                    }
                ]
            }
        };
    },
    onInput: function ({list}) {
        this.state.waiting = false;
        Array.isArray(list) && this.setState('outlines', list);
    },
    onMount: function () {
        setTimeout(() => this.initSortable(), 1000);
    },
    initSortable: function () {
        this.sortableOptions = {
            group: 'nested',
            sort: true,
            delay: 0,
            delayOnTouchOnly: false,
            touchStartThreshold: 0,
            disabled: false,
            store: null,
            animation: 150,
            easing: 'cubic-bezier(1, 0, 0, 1)',
            handle: '.move-handle',
            filter: '.ignore-elements',
            preventOnFilter: true,
            draggable: '.sortable-item',
            dataIdAttr: 'data-id',
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            swapThreshold: 1,
            invertSwap: true,
            invertedSwapThreshold: 1,
            direction: 'vertical',
            forceFallback: false,
            fallbackClass: 'sortable-fallback',
            fallbackOnBody: false,
            fallbackTolerance: 0,
            dragoverBubble: false,
            removeCloneOnHide: true,
            emptyInsertThreshold: 5,
            onEnd: e => {
                const fromParentIndex = $(e.from).data('parent-index'), fromIndex = fromParentIndex !== undefined ? fromParentIndex + '-' + e.oldIndex : e.oldIndex, toParentIndex = $(e.to).data('parent-index'), toIndex = toParentIndex !== undefined ? toParentIndex + '-' + e.newIndex : e.newIndex;
                fromIndex != toIndex && this.onCourseOutlineMove(fromIndex, toIndex, e.item);
            }
        };
        new Sortable(document.querySelector('.main-sortable-list'), this.sortableOptions);
        const nestedList = $('.nested-sortable-list');
        if (nestedList)
            for (const element of nestedList)
                new Sortable(element, this.sortableOptions);
    },
    onAddContent: function (type) {
        switch (this.selectedContentType = type) {
        case 'module':
            this.onCourseOutlineInsert({
                type: 'module',
                title: null,
                outlines: []
            });
            break;
        case 'RTXT':
        case 'FLIP':
        case 'MVID':
            window.Extensions.run('3C', {
                mode: 'create',
                type,
                callback: this.onCourseOutlineInsert.bind(this)
            });
            break;
        case 'MIVI':
            window.Extensions.run('InteractiveVideo', { mode: 'create' });
            break;
        case 'SMLT':
            window.Extensions.run('Simulation', { mode: 'action:assign' });
            break;
        case 'LIVE':
            this.onFindContent('livesession');
            break;
        case 'ASSM':
        case 'ASSG':
            window.Extensions.run('EvaluationPro', {
                mode: 'create',
                type,
                callback: this.onCourseOutlineInsert.bind(this)
            });
            break;
        }
    },
    onFindContent: function (type) {
        const payload = {
            targets: [type],
            label: `Search for ${ type }s to add`,
            formater: (target, results) => {
                const idKey = (target == 'livesession' ? 'session' : target) + 'Id';
                return results.map(item => {
                    return {
                        poster: item.poster,
                        title: item.title || item.name || item.topic,
                        subtitle: item.description,
                        route: `/${ target }/${ item[idKey] }`,
                        reference: item[idKey]
                    };
                });
            },
            callback: function (type, formated, raw) {
                this.onCourseOutlineInsert({
                    type: type == 'livesession' ? 'LIVE' : type,
                    reference: formated.reference,
                    title: formated.title,
                    subtitle: raw.description
                });
                window.Extensions.quit('SmartSearch');
            }.bind(this)
        };
        window.Extensions.run('SmartSearch', payload);
    },
    dismissProvider: function () {
        switch (this.selectedContentType) {
        case 'RTXT':
        case 'FLIP':
        case 'MVID':
            window.Extensions.quit('3C');
            break;
        case 'MIVI':
            window.Extensions.quit('InteractiveVideo');
            break;
        case 'SMLT':
            window.Extensions.quit('Simulation');
            break;
        case 'LIVE':
            window.Extensions.quit('SmartSearch');
            break;
        case 'ASSM':
        case 'ASSG':
            window.Extensions.quit('EvaluationPro');
            break;
        case 'BOOK':
            window.Extensions.quit('Library');
            break;
        }
        this.selectedContentType = null;
    },
    onToggleAddContent: function (emit, index) {
        this.state.mountModuleIndex = index;
        emit('open', this.contextModal);
    },
    onToggleEditContent: function ({outline, index}) {
        if (!outline)
            return;
        const {type, reference} = outline;
        switch (this.selectedContentType = type) {
        case 'RTXT':
        case 'FLIP':
        case 'MVID':
            window.Extensions.run('3C', {
                mode: 'create',
                type,
                reference,
                callback: function (updates) {
                    this.onApplyCourseOutlineEdit(index, updates);
                }.bind(this)
            });
            break;
        case 'MIVI':
            window.Extensions.run('InteractiveVideo', { mode: 'create' });
            break;
        case 'SMLT':
            window.Extensions.run('Simulation', {
                mode: 'action:assign',
                type,
                reference,
                callback: function (updates) {
                    this.onApplyCourseOutlineEdit(index, updates);
                }.bind(this)
            });
            break;
        case 'ASSM':
        case 'ASSG':
            window.Extensions.run('EvaluationPro', {
                mode: 'create',
                type,
                reference,
                callback: function (updates) {
                    this.onApplyCourseOutlineEdit(index, updates);
                }.bind(this)
            });
            break;
        case 'BOOK':
            window.Extensions.run('Library', {
                page: 'books',
                action: 'search'
            });
            break;
        }
    },
    onCourseOutlineInsert: function (outline) {
        if (!outline)
            return;
        const index = this.state.mountModuleIndex;
        if (index === null)
            this.state.outlines.push(outline);
        else {
            function getOutlineContainer(outlines, args) {
                const idx = Number(args.shift());
                if (args.length)
                    return getOutlineContainer(outlines[idx].outlines, args);
                return outlines[idx];
            }
            let target;
            if (String(index).includes('-')) {
                target = getOutlineContainer(this.state.outlines, index.split('-'));
                if (!target)
                    return;
                Array.isArray(target.outlines) ? target.outlines.push(outline) : target.outlines = [outline];
            } else {
                target = this.state.outlines[index];
                if (!target)
                    return;
                Array.isArray(target.outlines) ? target.outlines.push(outline) : target.outlines = [outline];
            }
            this.state.mountModuleIndex = null;
        }
        this.setStateDirty('outlines', this.state.outlines);
        this.emit('change', this.state.outlines);
        this.dismissProvider();
    },
    onCourseOutlineEdit: function (outline, index) {
        if (!outline)
            return;
        this.state.editOutline = {
            index,
            outline,
            fn: function (updates) {
                this.onApplyCourseOutlineEdit(index, updates);
            }.bind(this)
        };
    },
    onCourseOutlineMove: function (fromIndex, toIndex) {
        const _outline = function getValue(outlines, args) {
            const idx = args.shift();
            if (args.length)
                return getValue(outlines[idx].outlines, args);
            return outlines[idx];
        }(this.state.outlines, String(fromIndex).split('-'));
        if (!_outline)
            return;
        function operate(outlines, args, todo) {
            const idx = parseInt(args.shift());
            if (args.length) {
                if (!outlines[idx].hasOwnProperty('outlines'))
                    outlines[idx].outlines = [];
                return operate(outlines[idx].outlines, args, todo);
            }
            switch (todo) {
            case 'add':
                outlines.splice(idx, 0, _outline);
                break;
            case 'remove':
                outlines.splice(idx, 1);
                break;
            }
        }
        operate(this.state.outlines, String(fromIndex).split('-'), 'remove');
        operate(this.state.outlines, String(toIndex).split('-'), 'add');
        this.setStateDirty('outlines', this.state.outlines);
        this.emit('change', this.state.outlines);
    },
    onCourseOutlineDelete: function (index) {
        function eachIndex(outlines, args) {
            const idx = args.shift();
            if (args.length)
                return eachIndex(outlines[idx], args);
            outlines.outlines.splice(idx, 1);
        }
        this.emit('dialog', {
            type: 'warning',
            message: 'Are you sure about deleting this outline? The process is irreversible.',
            actions: {
                yes: {
                    active: true,
                    fn: function () {
                        String(index).includes('-') ? eachIndex(this.state.outlines, index.split('-')) : this.state.outlines.splice(index, 1);
                        this.setStateDirty('outlines', this.state.outlines);
                        this.emit('change', this.state.outlines.length ? this.state.outlines : '');
                    }.bind(this)
                }
            }
        });
    },
    onApplyCourseOutlineEdit: function (index, outline) {
        if (!outline)
            return;
        function eachIndex(outlines, args) {
            const idx = args.shift();
            if (args.length)
                return eachIndex(outlines[idx].outlines, args);
            return Object.assign(outlines[idx], outline);
        }
        String(index).includes('-') ? eachIndex(this.state.outlines, index.split('-')) : Object.assign(this.state.outlines[index], outline);
        this.setStateDirty('outlines', this.state.outlines);
        this.emit('change', this.state.outlines);
        this.dismissProvider();
    },
    onDismissEdit: function () {
        this.state.editOutline = false;
    },
    onPublish: function () {
        this.state.waiting = true;
        this.emit('update-course', 'isPublished', this.input.editable, function () {
            this.state.waiting = false;
        }.bind(this));
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Courses/create/Content/components/Outlines.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    module_Sortable = require("sortablejs"),
    Sortable = module_Sortable.default || module_Sortable,
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Outline_template = require("../../../components/Outline.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Outline_tag = marko_loadTag(Outline_template),
    ModuleCard_template = require("../../../components/ModuleCard.marko"),
    ModuleCard_tag = marko_loadTag(ModuleCard_template),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Preloader_template = require("../../../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    EditOutline_template = require("./EditOutline.marko"),
    EditOutline_tag = marko_loadTag(EditOutline_template),
    marko_attrs0 = {
        "class": "text-center"
      },
    marko_attrs1 = {
        "class": "w-100 py-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("fb1f7b"),
    marko_node0 = marko_createElement("img", {
        src: "/images/illustration/add-content.svg",
        alt: "Add Course Content Placeholder",
        style: "width:35%"
      }, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "text-muted"
      },
    marko_node4 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_attrs4 = {
        "class": "align-middle",
        style: "color:inherit"
      },
    marko_attrs5 = {
        "class": "position-relative"
      },
    marko_node6 = marko_createElement("br", null, "28", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "accordion collapse-icon accordion-icon-rotate"
      },
    marko_attrs7 = {
        "class": "main-sortable-list"
      },
    marko_node7 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "col"
      },
    marko_attrs9 = {
        "class": "font-medium-3"
      },
    marko_attrs10 = {
        "class": "col text-right"
      },
    marko_attrs11 = {
        "class": "btn btn-secondary m-25"
      },
    marko_attrs12 = {
        "class": "btn btn-secondary float-right mx-25"
      },
    marko_attrs13 = {
        "class": "align-middle",
        style: "color:inherit"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Module(out, { caption, idx }) {
    get_context_tag({
        __from: index_template,
        renderBody: function(out, {}, emit) {
          ModuleCard_tag({
              target: "module-" + idx,
              title: caption.title,
              subtitle: caption.subtitle,
              index: idx,
              editable: input.editable,
              class: "module-container border rounded my-1",
              renderBody: function(out) {
                if (Array.isArray(caption.outlines) && caption.outlines.length) {
                  marko_forOf(caption.outlines, function(outline, index) {
                    if (outline) {
                      const composedIndex = idx +'-'+ index

                      if (outline.type == "module") {
                        marko_dynamicTag(out, macro_Module, function() {
                          return {
                              idx: composedIndex,
                              caption: outline
                            };
                        }, null, null, null, __component, composedIndex);
                      } else {
                        Outline_tag(marko_assign({
                            index: composedIndex
                          }, outline, {
                            editable: input.editable
                          }), out, __component, composedIndex, [
                          [
                            "delete",
                            "onCourseOutlineDelete",
                            false,
                            [
                                composedIndex
                              ]
                          ],
                          [
                            "edit",
                            "onCourseOutlineEdit",
                            false,
                            [
                                outline,
                                composedIndex
                              ]
                          ],
                          [
                            "mandatory",
                            "onApplyCourseOutlineEdit",
                            false,
                            [
                                composedIndex
                              ]
                          ]
                        ]);
                      }
                    }
                  });
                }
              }
            }, out, __component, "0", [
            [
              "edit",
              "onApplyCourseOutlineEdit",
              false
            ],
            [
              "delete",
              "onCourseOutlineDelete",
              false
            ],
            [
              "toggle",
              "onToggleAddContent",
              false,
              [
                  emit
                ]
            ]
          ]);
        }
      }, out, __component, "37");
  }

  if ((!Array.isArray(state.outlines)) || (!state.outlines.length)) {
    out.be("div", marko_attrs0, "1", component);

    out.be("div", marko_attrs1, "2", component);

    out.n(marko_node0, component);

    out.n(marko_node1, component);

    out.n(marko_node2, component);

    out.n(marko_node3, component);

    out.be("h5", marko_attrs2, "7", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("Add some content to the course");
        }
      }, out, __component, "8");

    out.ee();

    out.n(marko_node4, component);

    out.n(marko_node5, component);

    get_context_tag({
        __from: index_template,
        renderBody: function(out, {}, emit) {
          out.be("button", marko_attrs3, "11", component, null, 0, {
              onclick: __component.d("click", emit, false, [
                  "open",
                  component.contextModal
                ])
            });

          out.be("span", marko_attrs4, "12", component);

          Locale_tag({
              text: "Select Content"
            }, out, __component, "13");

          out.ee();

          out.ee();
        }
      }, out, __component, "38");

    out.ee();

    out.ee();
  } else {
    out.be("div", marko_attrs5, "14", component);

    Row_tag({
        renderBody: function(out) {
          out.be("div", marko_attrs8, "16", component);

          out.be("h6", marko_attrs9, "17", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Course Outlines");
              }
            }, out, __component, "18");

          out.ee();

          out.ee();

          out.be("div", marko_attrs10, "19", component);

          if (input.editable) {
            get_context_tag({
                __from: index_template,
                renderBody: function(out, {}, emit) {
                  out.be("button", marko_attrs11, "20", component, null, 0, {
                      onclick: __component.d("click", emit, false, [
                          "open",
                          component.contextModal
                        ])
                    });

                  Bx_tag({
                      type: "plus",
                      class: "left",
                      style: "color:inherit"
                    }, out, __component, "21");

                  Locale_tag({
                      text: "Add",
                      class: "align-middle"
                    }, out, __component, "22");

                  out.ee();
                }
              }, out, __component, "39");
          }

          route_link_tag({
              href: "/preview-course/" + input.courseId,
              class: "btn btn-secondary m-25",
              renderBody: function(out) {
                Locale_tag({
                    text: "Preview"
                  }, out, __component, "24");
              }
            }, out, __component, "23");

          out.be("button", {
              "class": marko_classValue(("btn btn-" + (input.editable ? "primary" : "success")) + " m-25")
            }, "25", component, null, 1, {
              onclick: __component.d("click", "onPublish", false)
            });

          Locale_tag({
              text: input.editable ? "Publish" : "Unpublish"
            }, out, __component, "26");

          Preloader_tag({
              active: state.waiting,
              class: "float-right"
            }, out, __component, "27");

          out.ee();

          out.ee();
        }
      }, out, __component, "15");

    out.n(marko_node6, component);

    out.be("div", marko_attrs6, "29", component);

    out.be("div", marko_attrs7, "30", component);

    marko_forOf(state.outlines, function(outline, index) {
      if (outline) {
        if (outline.type == "module") {
          marko_dynamicTag(out, macro_Module, function() {
            return {
                idx: index,
                caption: outline
              };
          }, null, null, null, __component, index);
        } else {
          Outline_tag(marko_assign({
              index: index,
              editable: input.editable
            }, outline), out, __component, index, [
            [
              "edit",
              "onCourseOutlineEdit",
              false,
              [
                  outline,
                  index
                ]
            ],
            [
              "delete",
              "onCourseOutlineDelete",
              false,
              [
                  index
                ]
            ]
          ]);
        }
      }
    });

    out.ee();

    out.ee();

    out.n(marko_node7, component);

    if (state.outlines.length > 10) {
      get_context_tag({
          __from: index_template,
          renderBody: function(out, {}, emit) {
            out.be("button", marko_attrs12, "32", component, null, 0, {
                onclick: __component.d("click", emit, false, [
                    "open",
                    component.contextModal
                  ])
              });

            Bx_tag({
                type: "plus",
                class: "left",
                style: "color:inherit"
              }, out, __component, "33");

            out.be("span", marko_attrs13, "34", component);

            Locale_tag({
                text: "Add"
              }, out, __component, "35");

            out.ee();

            out.ee();
          }
        }, out, __component, "40");
    }

    out.ee();

    if (state.editOutline) {
      EditOutline_tag(state.editOutline, out, __component, "36", [
        [
          "dismiss",
          "onDismissEdit",
          false
        ],
        [
          "edit-content",
          "onToggleEditContent",
          false,
          [
              state.editOutline
            ]
        ]
      ]);
    }
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
